import Vue from 'vue'
import VueRouter from 'vue-router'
import AppHome from '../components/Home.vue'
import AppAbout from '../components/About.vue'
import AppNews from '../components/News.vue'
import AppNewsDetail from '../components/NewsDetail.vue'
import AppCovs from '../components/Covs.vue'
import AppCovsDetail from '../components/CovsDetail.vue'
import AppLdar from '../components/Ldar.vue'
import AppLdarDetail from '../components/LdarDetail.vue'
import AppEnvironmental from '../components/Environmental.vue'
import AppSoilRemediation from '../components/SoilRemediation.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: AppHome
  },
  {
    path: '/about',
    name: 'About',
    component: AppAbout
  },
  {
    path: '/news',
    name: 'News',
    component: AppNews
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: AppNewsDetail
  },
  {
    path: '/covs',
    name: 'Covs',
    component: AppCovs
  },
  {
    path: '/covs/:id',
    name: 'CovsDetail',
    component: AppCovsDetail
  },
  {
    path: '/ldar',
    name: 'Ldar',
    component: AppLdar
  },
  {
    path: '/ldar/:id',
    name: 'LdarDetail',
    component: AppLdarDetail
  },
  {
    path: '/environmental',
    name: 'Environmental',
    component: AppEnvironmental
  },
  {
    path: '/soil-remediation',
    name: 'SoilRemediation',
    component: AppSoilRemediation
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局后置钩子，确保切换导航时页面回到顶部
router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router